import { DateParserService } from "libraries/service/date/dateParser.service";

declare const wenji: IWenji;

// Angular
import { Injectable } from '@angular/core';

// Afidium
import { IWenji } from 'libraries/interfaces/IWenji';
import { DateMomentPipe } from 'libraries/date/dateMoment.pipe';

@Injectable()
export class DatesService {
    private dateFormat: { momentMedium: string } = JSON.parse(wenji.ui.dateFormat);

    constructor(
        private dateMoment: DateMomentPipe,
        private dateParserService: DateParserService,
    ) { }

    public formatDate(date: string|Date, format: string): string {
        return `${this.dateMoment.transform(date, this.dateFormat[format])}`;
    }

    /**
     * @param inputDateStr can be a date or an expression supported by {@link DateParserService}
     * @return If the input was converted, returns the resulting date formated as "YYYY-MM-DD". Otherwise, returns the untouched input.
     */
    public convertExpressionToStaticDateStr<TParameters>(inputDateStr: string): string {
        const parsedDate: Date = this.dateParserService.parse(inputDateStr);
        return parsedDate ? this.dateMoment.transform(parsedDate, "YYYY-MM-DD") : inputDateStr;
    }
}
